// https://docs.fineuploader.com/tag/3.8.2/features/handling-errors.html
export default {
    'it-IT': {
        creditCard: {
            cardEndsWith: 'termina con',
            cardExpiresOn: 'Scade il',
            noCardSaved: 'Al momento non hai nessun metodo di pagamento salvato!',
            info1: 'Per aggiungerne uno ti basta salvare la carta di credito durante il tuo prossimo acquisto.',
            info2: 'Questa operazione ti permetterà di velocizzare le procedure di acquisto future!',
            info3: 'Le informazioni saranno archiviate in sicurezza presso un portale sicuro con cifratura della trasmissione dei dati e nel rispetto del trattamento dei dati sensibili. Nessun dato della carta verrà trasmesso o registrato da {site}.',
            continueShopping: 'Continua gli acquisti',
            error: 'Si è verificato un errore. Si prega di riprovare più tardi.'
        },
        deleteCard: {
            confirmMessage: 'Sei sicuro di voler rimuovere definitivamente questo metodo di pagamento?',
            delete: 'Elimina carta',
            cancel: 'Annulla'
        }
    },
    'fr-FR': {
        creditCard: {
            cardEndsWith: 'se termine par',
            cardExpiresOn: 'Expire le',
            noCardSaved: 'Vous n\'avez actuellement aucun moyen de paiement enregistré!',
            info1: 'Pour en ajouter un, il vous suffit de sauvegarder votre carte de crédit lors de votre prochain achat.',
            info2: 'Cela permettra d\'accélérer les futures procédures d\'achat!',
            info3: 'Les informations seront stockées en toute sécurité dans un portail sécurisé avec cryptage de la transmission des données et en conformité avec le traitement des données sensibles. Aucune donnée de la carte ne sera transmise ou enregistrée par {site}.',
            continueShopping: 'Continuer mes achats',
            error: 'Une erreur s\'est produite. Veuillez réessayer plus tard.'
        },
        deleteCard: {
            confirmMessage: 'Êtes-vous sûr de vouloir supprimer définitivement ce mode de paiement?',
            delete: 'Supprimer la carte',
            cancel: 'Annuler'
        }
    },
    'es-ES': {
        creditCard: {
            cardEndsWith: 'termina en',
            cardExpiresOn: 'Caduca el',
            noCardSaved: '¡Actualmente no tienes ningún método de pago guardado!',
            info1: 'Para añadir uno, simplemente guarda los datos de tu tarjeta de crédito durante tu próxima compra.',
            info2: '¡Esta operación te permitirá acelerar el procedimiento de compra en el futuro!',
            info3: 'La información se almacenará de forma segura en un portal seguro con la codificación de la transmisión de datos y de conformidad con el tratamiento de datos sensibles. Ningún dato de la tarjeta será transmitido o registrado por {site}.',
            continueShopping: 'Continuar comprando',
            error: 'Se ha producido un error. Por favor, inténtalo más tarde.'
        },
        deleteCard: {
            confirmMessage: '¿Estás seguro de eliminar definitivamente este método de pago?',
            delete: 'Eliminar tarjeta',
            cancel: 'Cancelar'
        }
    },
    'en-GB': {
        creditCard: {
            cardEndsWith: 'ends with',
            cardExpiresOn: 'Expires on',
            noCardSaved: 'You currently have no payment method saved!',
            info1: 'To add one, simply save your credit card during your next purchase.',
            info2: 'This will speed up future purchase procedures!',
            info3: 'Your information will be securely stored on a secure portal with encrypted data transmission and sensitive data handling. No card data will be transmitted or recorded by {site}.',
            continueShopping: 'Continue shopping',
            error: 'An error has occurred. Please try again later.'
        },
        deleteCard: {
            confirmMessage: 'Are you sure you want to permanently remove this payment method?',
            delete: 'Delete card',
            cancel: 'Cancel'
        }
    },
    'en-US': {
        creditCard: {
            cardEndsWith: 'ends with',
            cardExpiresOn: 'Expires on',
            noCardSaved: 'You currently have no payment method saved!',
            info1: 'To add one, simply save your credit card during your next purchase.',
            info2: 'This will speed up future purchase procedures!',
            info3: 'Your information will be securely stored on a secure portal with encrypted data transmission and sensitive data handling. No card data will be transmitted or recorded by {site}.',
            continueShopping: 'Continue shopping',
            error: 'An error has occurred. Please try again later.'
        },
        deleteCard: {
            confirmMessage: 'Are you sure you want to permanently remove this payment method?',
            delete: 'Delete card',
            cancel: 'Cancel'
        }
    },
    'de-DE': {
        creditCard: {
            cardEndsWith: 'endet mit',
            cardExpiresOn: 'Läuft ab am',
            noCardSaved: 'Sie haben derzeit keine Zahlungsmethode gespeichert!',
            info1: 'Um eine hinzuzufügen, speichern Sie einfach Ihre Kreditkarte bei Ihrem nächsten Einkauf.',
            info2: 'Dies wird zukünftige Kaufvorgänge beschleunigen!',
            info3: 'Ihre Daten werden auf einem sicheren Portal mit verschlüsselter Datenübertragung und sensiblem Datenhandling sicher gespeichert. Es werden keine Kartendaten übertragen oder von {site} aufgezeichnet.',
            continueShopping: 'Weiter einkaufen',
            error: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später noch einmal.'
        },
        deleteCard: {
            confirmMessage: 'Sind Sie sicher, dass Sie diese Zahlungsmethode dauerhaft entfernen möchten?',
            delete: 'Karte löschen',
            cancel: 'Abbrechen'
        }
    },
    'en-AU': {
        creditCard: {
            cardEndsWith: 'ends with',
            cardExpiresOn: 'Expires on',
            noCardSaved: 'You currently have no payment method saved!',
            info1: 'To add one, simply save your credit card during your next purchase.',
            info2: 'This will speed up future purchase procedures!',
            info3: 'Your information will be securely stored on a secure portal with encrypted data transmission and sensitive data handling. No card data will be transmitted or recorded by {site}.',
            continueShopping: 'Continue shopping',
            error: 'An error has occurred. Please try again later.'
        },
        deleteCard: {
            confirmMessage: 'Are you sure you want to permanently remove this payment method?',
            delete: 'Delete card',
            cancel: 'Cancel'
        }
    }
}